import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import ClientAddressForm from '@/components/views/ClientView/ClientAddressForm.vue';
import AddressConfig from '@/models/interfaces/Address';

interface Props {
    clientAddresses: AddressConfig[];
    isNewClient: boolean;
    addressTypes: string[];
    canAccessLogistics: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientAddressCarousel',
  props: {
    clientAddresses: null,
    isNewClient: { type: Boolean },
    addressTypes: null,
    canAccessLogistics: { type: Boolean }
  },
  emits: ["add-address", "remove-address", "update-address", "default-address-change"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'add-address'): void;
    (e: 'remove-address', index: number, address: AddressConfig): void;
    (e: 'update-address', index: number, address: AddressConfig): void;
    (e: 'default-address-change', address: AddressConfig, isDefault: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    clientAddresses: AddressConfig[];
    isNewClient: boolean;
    addressTypes: string[];
    canAccessLogistics: boolean;
};





const activeIndex = ref(0);
const direction = ref('carousel-next');

function prev() {
    if (activeIndex.value > 0) {
        direction.value = 'carousel-prev';
        activeIndex.value--;
    }
}

function next() {
    if (activeIndex.value < props.clientAddresses.length - 1) {
        direction.value = 'carousel-next';
        activeIndex.value++;
    }
}

function onAddAddress() {
    emit('add-address');

    direction.value = 'carousel-next';
    setTimeout(() => {
        activeIndex.value = props.clientAddresses.length - 1;
    }, 0);
}

function onRemoveAddress(index: number, address: AddressConfig) {
    emit('remove-address', index, address);

    direction.value = 'carousel-prev';
    setTimeout(() => {
        if (activeIndex.value >= props.clientAddresses.length) {
            activeIndex.value = Math.max(0, props.clientAddresses.length - 1);
        }
    }, 0);
}

const uniqueAddressTypes = computed(() => {
    const map = new Map<string, any>();

    props.addressTypes.forEach((type: any) => {
        map.set(type.code, type); // 👈 unique by `code`
    });

    return [...map.values()];
});

function getFilteredTypes(address: AddressConfig) {
    const currentType = address?.addressType;
    const usedTypes = new Set(props.clientAddresses.map((address: AddressConfig) => address.addressType));

    const available = uniqueAddressTypes.value.filter((type: any) => !usedTypes.has(type.id));

    if (currentType) {
        return [uniqueAddressTypes.value.find((type: any) => type.id === currentType), ...available];
    }

    return available;
}

expose({ activeIndex });

return { __sfc: true,props, emit, activeIndex, direction, prev, next, onAddAddress, onRemoveAddress, uniqueAddressTypes, getFilteredTypes, ClientAddressForm }
}

})